<template>
  <!-- <div class="pc-note__openeditem" :class="{active:isActive}" @contextmenu="contextmenuHandler" @click="goHandler">
    <div class="header">
      <icon-book v-if="isNotebook" class="static"/>
      <icon-file-alt v-if="isNote" class="static"/>
      <span class="content">{{data.openedTime | datetime}} 打开</span>
      <div class="pc-icon close" title="关闭"><i class="el-icon-close"/></div>
    </div>
    <div class="name">{{isNotebook ? data.notebookName : data.noteName}}</div>
  </div> -->
  <div class="pc-note__openeditem" v-if="isNotebook">
    <div class="item" :class="{current: isCurrent(data.notebookId, '')}" :title="data.openedTime | datetime" @click="goHandler(data.notebookId, '')">
      <icon-book class="static"/>
      <div class="name">{{data.notebookName}}</div>
      <div class="pc-icon close" title="关闭" @click.stop="removeHandler(data)"><i class="el-icon-close"/></div>
    </div>
    <div class="item notebook-note" :class="{current: isCurrent(item.notebookId, item.noteId)}" v-for="item in data.notes" :key="item.noteId" :title="item.openedTime | datetime" @click="goHandler(item.notebookId, item.noteId)">
      <icon-file-alt class="static"/>
      <div class="name">{{item.noteName}}</div>
      <div class="pc-icon close" title="关闭" @click.stop="removeHandler(item)"><i class="el-icon-close"/></div>
    </div>
  </div>
  <div class="pc-note__openeditem" v-else>
    <div class="item" :class="{current: isCurrent('', data.noteId)}" :title="data.openedTime | datetime" @click="goHandler('', data.noteId)">
      <icon-file-alt class="static"/>
      <div class="name">{{data.noteName}}</div>
      <div class="pc-icon close" title="关闭" @click.stop="removeHandler(data)"><i class="el-icon-close"/></div>
    </div>
  </div>
</template>

<script>
import IconBook from '@/components/icon/Book.vue'
import IconFileAlt from '@/components/icon/FileAlt.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { createPopper } from '@popperjs/core'

export default {
  components: {
    IconBook,
    IconFileAlt
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      firstOpenedItem: 'workbench/opened/first'
    }),
    isNotebook () {
      return this.data.type === 'NOTEBOOK'
    },
    // isNote () {
    //   return this.data.type === 'NOTE'
    // },
    // isActive () {
    //   return (this.isNotebook && this.data.id === this.$route.params.notebookId) ||
    //     (this.isNote && this.data.id === this.$route.params.noteId)
    // },
    isCurrent () {
      return (notebookId = '', noteId = '') => {
        return (this.$route.params.notebookId || '') === notebookId && (this.$route.params.noteId || '') === noteId
      }
    }
  },
  methods: {
    ...mapMutations('contextmenu', {
      setVisible: 'SET_VISIBLE',
      setType: 'SET_TYPE',
      setData: 'SET_DATA'
    }),
    ...mapActions({
      removeOpened: 'workbench/opened/remove'
    }),
    contextmenuHandler (event) {
      const x = event.clientX
      const y = event.clientY
      const virtualElement = {
        getBoundingClientRect: () => ({
          width: 0,
          height: 0,
          top: y,
          right: x,
          bottom: y,
          left: x
        })
      }

      this.setType('WORKBENCH_SIDEBAR_OPENED_ITEM')
      this.setVisible(true)
      this.$nextTick(() => {
        window.contextmenuPopper = createPopper(virtualElement, window.document.getElementById('pc-contextmenu'), {
          placement: 'bottom-start',
          strategy: 'fixed'
        })
      })
    },
    goHandler (notebookId, noteId) {
      if (this.isCurrent(notebookId, noteId)) {
        return
      }
      if (notebookId !== '' && noteId === '') {
        this.$router.push({
          name: 'workbenchNotebook',
          params: {
            notebookId
          }
        })
      } else if (notebookId !== '' && noteId !== '') {
        this.$router.push({
          name: 'workbenchNotebookNote',
          params: {
            notebookId,
            noteId
          }
        })
      } else if (notebookId === '' && noteId !== '') {
        this.$router.push({
          name: 'workbenchNote',
          params: {
            noteId
          }
        })
      }
    },
    async removeHandler (data) {
      await this.removeOpened({
        notebookId: data.notebookId,
        noteId: data.noteId
      })

      // 关闭的是笔记本，且当前打开的就属于关闭的笔记本
      if (data.type === 'NOTEBOOK' && this.$route.params.notebookId === data.notebookId) {
        this.$router.push('/workbench')
        return
      }

      if (this.isCurrent(data.notebookId, data.noteId)) {
        this.$router.push('/workbench')
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-note__openeditem {
  user-select: none;
  cursor: pointer;
  border-top: 1px solid $border-color-3;
  // padding: .5rem 1rem;

  &:first-of-type {
    border-top: none;
  }

  // &:not(.active):hover {
  //   background: rgb(236, 245, 255);
  // }

  &.active {
    cursor: default;
  }

  .static,.close {
    color: $color-b3;
  }

  .close {
    min-height: 1.6rem;
    height: 1.6rem;
    min-width: 1.6rem;
    border-radius: 0;
    background: transparent;
    color: $color-b3;

    &:hover {
      color: $color-main;
      background: transparent;
    }
  }

  .header {
    display: flex;
    flex-direction: row;
    height: 2rem;
    align-items: center;

    .content {
      width: 0;
      flex-grow: 1;
      margin: 0 .5rem;
      color: $color-b3;
    }
  }

  .name {
    line-height: 1.8rem;
  }

  .item {
    display: flex;
    flex-direction: row;
    padding: .5rem .5rem .5rem 1rem;

    .static {
      margin-right: .4rem;
      height: 1.6rem;
    }

    .name {
      width: 0;
      flex-grow: 1;
      line-height: 1.6rem;
      margin-right: .2rem;
    }

    &:hover {
      background: rgb(236, 245, 255);
    }

    &.current {
      background: rgb(236, 245, 255);
      color: $color-special;
    }
  }

  .notebook-note {
    padding-left: 2.5rem;
  }
}
</style>
